import {
    getCustomerSubscription,
    listCustomerSubscriptions
} from './queries';
import {
    activateCustomerSubscription,
    cancelCustomerSubscription,
    createCustomerSubscription,
    deleteCustomerSubscription,
    updateCustomerSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {CustomerSubscription} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListCustomerSubscriptions = {
    listCustomerSubscriptions: { items: CustomerSubscription[], nextToken: string }
}

export type GetCustomerSubscription = {
    getCustomerSubscription: CustomerSubscription
}

export type CreateCustomerSubscription = {
    createCustomerSubscription: CustomerSubscription
}

export type UpdateCustomerSubscription = {
    updateCustomerSubscription: CustomerSubscription
}

export type ActivateCustomerSubscription = {
    activateCustomerSubscription: CustomerSubscription
}

export type CancelCustomerSubscription = {
    cancelCustomerSubscription: CustomerSubscription
}

export type DeleteCustomerSubscription = {
    deleteCustomerSubscription: string
}


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListCustomerSubscriptions>>({
                                                                               query: listCustomerSubscriptions,
                                                                               variables: {
                                                                                   ...query
                                                                               },
                                                                           });
    return {
        items: response.data?.listCustomerSubscriptions.items,
        nextToken: response.data?.listCustomerSubscriptions.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetCustomerSubscription>>({
                                                                             query: getCustomerSubscription,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getCustomerSubscription;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateCustomerSubscription>>({
                                                                                query: createCustomerSubscription,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createCustomerSubscription;
};

export const update = async (_id: string, record: CustomerSubscription) => {
    const { created: _created, createdByUsername: _createdByUsername, createdByUser: _createdByUser, updated: _updated, updatedByUsername: _updatedByUsername, ...cleanData } = record;

    const response = await client.graphql<GraphQLQuery<UpdateCustomerSubscription>>({
                                                                                query: (updateCustomerSubscription),
                                                                                variables: {input: cleanData},
                                                                            });
    return response.data?.updateCustomerSubscription;
};

export const activateRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<ActivateCustomerSubscription>>({
        query: activateCustomerSubscription,
        variables: { id }
    });
    return response.data?.activateCustomerSubscription;
};

export const cancelRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<CancelCustomerSubscription>>({
        query: cancelCustomerSubscription,
        variables: { id }
    });
    return response.data?.cancelCustomerSubscription;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCustomerSubscription>>({
                                                                                query: (deleteCustomerSubscription),
                                                                                variables: {input: {id: id}},

                                                                            });
    return response.data?.deleteCustomerSubscription;
};
